/* eslint-disable no-unused-vars */
import React, { useState, useRef, useCallback } from "react";
import hamburgerIconClosed from "../../assests/images/maruti/HamburgerCloseIcon.png";
import MessageIcon from "../../assests/images/messageIcon.svg";
import ReadMessageIcon from "../../assests/images/read_notification.png";
import event_filter from "../../assests/images/event-filter.svg";
import parse from "html-react-parser";
import { dateFormat } from "../../utils";
import emptyNotification from "../../assests/images/empty_notifications.png";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import "./style.scss";
import { Button, Tooltip, Popover, Menu, Dropdown } from "antd";
import NotificationDetailView from "./NotificationDetailView";

function Notification({
  notificationList,
  readNotification,
  unreadNotification,
  setShowNotification,
  fetchMoreNotifications,
  handleReadNotification,
  fetchInitialData = () => {},
  loading,
  eventType,
}) {
  const [activeTab, setActiveTab] = useState(0);

  const observer = useRef();
  const [expanded, setExpanded] = useState(false);

  const lastNotificationRef = useCallback(
    (node) => {
      if (!node) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchMoreNotifications(activeTab);
        }
      });

      observer.current.observe(node);
    },
    [fetchMoreNotifications, activeTab]
  );
  // const observerRead = useRef();

  // const lastNotificationReadRef = useCallback(
  //   (node) => {
  //     if (!node) return;

  //     if (observerRead.current) observerRead.current.disconnect();

  //     observerRead.current = new IntersectionObserver((entries) => {
  //       if (entries[0].isIntersecting) {
  //         fetchMoreNotifications(activeTab);
  //       }
  //     });

  //     observerRead.current.observe(node);
  //   },
  //   [fetchMoreNotifications, activeTab]
  // );

  // useEffect(() => {
  //   if (notificationList.length > 0) {
  //     lastNotificationRef.current = notificationList.length - 1;
  //   }
  // }, [notificationList]);

  const tabs = [
    { id: 0, title: "All" },
    { id: 1, title: "Read" },
    { id: 2, title: "Unread" },
  ];

  const handleActiveTab = (type) => {
    if (type === "All") setActiveTab(0);
    else if (type === "Read") setActiveTab(1);
    else if (type === "Unread") setActiveTab(2);
  };
  const handleFilterChange = (e) => {
    fetchInitialData(e.key);
  };

  const eventTypeMenu = (
    <Menu onClick={handleFilterChange}>
      {eventType.map((item) => (
        <Menu.Item key={item.value}>{item.label}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div
      style={{
        backgroundColor: "white",
        width: "520px",
        position: "absolute",
        right: 12,
        top: 75,
        marginTop: 5,
        borderRadius: 10,
        zIndex: 50,
        boxShadow: "1px 0px 15px 5px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          padding: "12px 20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{ fontWeight: "800", fontSize: 14 }}
          className="d-flex align-items-center"
        >
          Notifications
          <Tooltip title="Refresh">
            <ReloadOutlined
              onClick={(e) => {
                e.stopPropagation();
                fetchInitialData();
              }}
              style={{
                cursor: "pointer",
                fontSize: "20px",
                color: "#1890ff",
                transition: "all 0.3s",
                marginLeft: "10px",
              }}
              spin={loading}
            />
          </Tooltip>
        </p>

        {/* <img
          src={hamburgerIconClosed}
          style={{ width: "12px", cursor: "pointer" }}
          onClick={() => setShowNotification(false)}
        /> */}
        <div style={{ cursor: "pointer" }}>
          <img
            src={hamburgerIconClosed}
            style={{ width: "12px" }}
            onClick={() => {
              setShowNotification(false);
            }}
          />
        </div>
      </div>
      <div style={{ width: "100%", borderTop: "1px solid #DBDBDB" }}></div>

      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 20px",
        }}
      >
        <div style={{ display: "flex", width: "50%" }}>
          {tabs.map((item) => (
            <span
              key={item.id}
              style={{
                cursor: "pointer",
                marginRight: "15px",
                color: item.id === activeTab ? "#2E77D0" : "",
              }}
              onClick={() => handleActiveTab(item.title)}
            >
              {item.title}
            </span>
          ))}
        </div>

        <div
          style={{ width: "50%", textAlign: "right" }}
          onClick={() => {
            handleReadNotification();
          }}
        >
          <span style={{ color: "#2E77D0", cursor: "pointer" }}>
            Mark All as Read
          </span>
        </div>
        <div className="ml-05">
          <Dropdown overlay={eventTypeMenu}>
            <Tooltip title="Event Filter">
              {/* <FilterOutlined
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  color: "#1890ff",
                  transition: "all 0.3s",
                  marginLeft: "10px",
                }}
              /> */}
              <img
                src={event_filter}
                style={{ width: "23px" }}
                className="pointer"
              />
            </Tooltip>
          </Dropdown>
        </div>
      </div>
      <div style={{ width: "100%", borderTop: "1px solid #DBDBDB" }}></div>
      <div
        style={{
          overflowY: "scroll",
          minHeight: "40vh",
          maxHeight: "70vh",
          scrollbarWidth: "none",
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        {activeTab == 0 &&
          notificationList &&
          notificationList.map((item, index) => (
            <NotificationItem
              type={"allNotification"}
              item={item}
              handleReadNotification={handleReadNotification}
              activeTab={activeTab}
              activeNotificationListLength={notificationList.length - 1}
              lastNotificationRef={
                index === notificationList.length - 1
                  ? lastNotificationRef
                  : null
              }
              index={index}
              key={index}
              expanded={expanded}
              setExpanded={setExpanded}
            />
          ))}
        {activeTab == 1 &&
          readNotification &&
          readNotification.map((item, index) => (
            <NotificationItem
              tupe={"readNotification"}
              item={item}
              handleReadNotification={() => {}}
              activeTab={activeTab}
              activeNotificationListLength={readNotification.length - 1}
              lastNotificationRef={
                index === readNotification.length - 1
                  ? lastNotificationRef
                  : null
              }
              index={index}
              key={index}
            />
          ))}
        {activeTab == 2 &&
          unreadNotification &&
          unreadNotification.map((item, index) => (
            <NotificationItem
              type={"unreadNotification"}
              item={item}
              handleReadNotification={handleReadNotification}
              activeTab={activeTab}
              activeNotificationListLength={unreadNotification.length - 1}
              lastNotificationRef={
                index === unreadNotification.length - 1
                  ? lastNotificationRef
                  : null
              }
              index={index}
              key={index}
            />
          ))}
        {activeTab == 0 && notificationList?.length == 0 && (
          <EmptyNotification />
        )}
        {activeTab == 1 && readNotification?.length == 0 && (
          <EmptyNotification />
        )}

        {activeTab == 2 && unreadNotification?.length == 0 && (
          <EmptyNotification />
        )}
      </div>
    </div>
  );
}

const EmptyNotification = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "60px 0",
      }}
    >
      <img src={emptyNotification} style={{ width: "70%" }} />
      <p style={{ margin: "20px", textAlign: "center", width: "70%" }}>
        We’ll let you know when there will be something to update you.
      </p>
    </div>
  );
};

function NotificationItem({
  item,
  activeTab,
  activeNotificationListLength,
  lastNotificationRef,
  handleReadNotification,
  index,
  type,
  expanded,
  setExpanded,
}) {
  const handleMessage = (item) =>
    item?.channels[0]?.channelType
      ? item?.channels[0]?.message
      : item?.channels?.default?.message;

  const handleTitle = (item) =>
    item?.channels[0]?.channelType
      ? item?.channels[0]?.title
      : item?.channels?.default?.title;

  const message = handleMessage(item) || "";

  const toggleExpanded = () => setExpanded((prev) => !prev);
  const limit = 20;
  const shortMessage = message.slice(0, limit);
  const shouldTruncate = message.length > limit;

  const [openPopover, setOpenPopover] = useState(false);
  const [notificationDetail, setNotificationDetail] = useState({
    data: {},
    open: false,
  });

  const handleOpenChange = (newOpen) => {
    setOpenPopover(newOpen);
  };

  const openDetails = (item) => {
    setNotificationDetail({ data: item, open: true });
  };
  return (
    <div ref={lastNotificationRef}>
      <NotificationDetailView
        item={notificationDetail?.data || {}}
        open={notificationDetail?.open || false}
        setOpen={() => {
          setNotificationDetail({ data: {}, open: false });
        }}
      />
      <div
        className="notification-item"
        style={{
          backgroundColor: activeTab === 0 && item.read ? "#F6F7FBE5" : "white",
          cursor: "pointer",
          borderBottomLeftRadius:
            activeNotificationListLength === index ? 10 : 0,
          borderBottomRightRadius:
            activeNotificationListLength === index ? 10 : 0,
        }}
        onClick={() => {
          handleReadNotification(item.id, type);
          openDetails(item);
        }}
      >
        <div>
          <img
            src={!item.read ? MessageIcon : ReadMessageIcon}
            style={{ width: "25px" }}
          />
        </div>
        <div style={{ marginLeft: 10, width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <p
              style={{
                marginBottom: 5,
                fontWeight: 600,
                color: item.read ? "#656875" : "#2E77D0",
              }}
            >
              {handleTitle(item)}
            </p>
            <p
              style={{
                marginBottom: 5,
                color: "#8D93A1",
                fontSize: 12,
                display: "flex",
                marginRight: item.read ? 9 : 0,
              }}
            >
              {dateFormat(item.updatedAt)}
              {/* {!item.read ? (
                <div
                  style={{
                    backgroundColor: "#2E77D0",
                    height: 7,
                    width: 7,
                    borderRadius: 50,
                    marginLeft: 4,
                  }}
                ></div>
              ) : null} */}
            </p>
          </div>
          {/* <Popover
            style={{ width: "100px !important" }}
            className="notification-popover"
            onCancel={() => setOpenPopover(false)}
            placement="topLeft"
            content={
              <p
                style={{
                  marginBottom: 0,
                  fontSize: 13,
                  color: item.read ? "#838797" : "black",
                  width: "300px",
                }}
              >
                {parse(handleMessage(item) || "")}
                {item?.channels?.default?.file?.length > 0 && (
                  <div>
                    {item?.channels?.default?.file?.map((file) => (
                      <a
                        key={index}
                        href={file?.url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ marginRight: 10, display: "block" }}
                      >
                        {file?.url?.split("/").pop()}
                      </a>
                    ))}
                  </div>
                )}
              
                <p>
                  {item?.actions?.length > 0 &&
                    item?.actions?.map((actionData, index) => {
                      if (actionData?.actionType?.toUpperCase() === "BUTTON") {
                        return (
                          <Button
                            key={index}
                            className="save-btn"
                            style={{
                              padding: "2px",
                              height: "25px",
                              fontSize: "11px",
                            }}
                            onClick={() =>
                              window.open(actionData?.url, "_blank")
                            }
                          >
                            {actionData?.title}
                          </Button>
                        );
                      } else if (
                        actionData?.actionType?.toUpperCase() === "LINK"
                      ) {
                        return (
                          <a
                            key={index}
                            href={actionData?.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {actionData?.title}
                          </a>
                        );
                      }
                      return null;
                    })}
                </p>
              </p>
            }
            title={
              <div style={{ maxWidth: "400px" }}>
                <p>{handleTitle(item)}</p>
              </div>
            }
            trigger="click"
            open={openPopover}
            onOpenChange={handleOpenChange}
          >  */}
          <span
            style={{
              color: item.read ? "#838797" : "#1890ff",
              cursor: "pointer",
              // marginLeft: "5px",
              // display: "inline-block",
            }}
          >
            {parse((handleMessage(item) || "").slice(0, 50))}
          </span>
          {/* </Popover> */}
        </div>
      </div>
      {activeNotificationListLength !== index ? (
        <div style={{ width: "100%", borderTop: "1px solid #DBDBDB" }}></div>
      ) : null}
    </div>
  );
}

export default Notification;
